import { useState } from 'react';

export const useIsBrave = () => {
  const [isBrave, setIsBrave] = useState(false);

  const detectBrave = async (): Promise<boolean> => {
    const nav = navigator as any;

    // Brave exposes this property
    if (nav.brave && typeof nav.brave.isBrave === 'function') {
      return await nav.brave.isBrave();
    }

    // fallback detection by blocking known Brave features
    if (!navigator.plugins.length && !navigator.mimeTypes.length) {
      return true;
    }

    return false;
  };

  return {
    isBrave,
    detectBrave: async () => {
      const result = await detectBrave();
      setIsBrave(result);
      return result;
    },
  };
};
